import api from "../../api";
import ENDPOINTS from "../../api/endpoints";
import UserAuthStore from "../../store/userStore";
import { FileStore } from "../../store/fileUploadStore";
import useSessionIdStore from "../../store/useSessionIdStore";
import logger from "../../services/Logger";

export const DeleteUploadedFile = async (
  file__path,
  chat_id,
  fileToBeDeleted,
  space
) => {
  const files = FileStore.getState().files;
  const new_files = files.filter((file) => file.file__path !== file__path);
  const { user, orgId } = UserAuthStore.getState();

  if (!file__path) {
    FileStore.setState({
      files: files.filter((file) => file !== fileToBeDeleted),
    });
    return;
  }

  try {
    const ownerId = space?.owner_id ? space?.owner_id : user?.uid;
    const session_id = useSessionIdStore.getState().session_id;

    // Optimistic update — remove from UI immediately before awaiting API calls
    FileStore.setState({ files: new_files });

    await api({
      method: "POST",
      url: ENDPOINTS.REMOVE_FILE_FROM_SPARK,
      data: {
        chat_id,
        org_id: orgId,
        owner_id: ownerId,
        file_name: fileToBeDeleted?.name,
        file_size: fileToBeDeleted?.size,
        file_path: file__path,
        asset_id: fileToBeDeleted?.asset_id,
        space_id: space?.space_id ?? null,
        by: user?.uid,
        session_id,
      },
    });
  } catch (error) {
    logger.error('deleteFileFromDb', 'Error deleting file', { error: error.message, file__path });
  }
};
